__turbopack_context__.v({
  "locked": "pageWrapper-module-scss-module__IbRHkW__locked",
  "padtop": "pageWrapper-module-scss-module__IbRHkW__padtop",
  "searchBarBorder": "pageWrapper-module-scss-module__IbRHkW__searchBarBorder",
});
